// Shared name-normalization used for organizer self-identification fallback
// matching (client `roundSync.ts` and server `routes_game.ts`). Both sides
// must stay in sync or a name that "matches" on one side and not the other
// silently reintroduces the ambiguous-identity bug.
//
// Deliberately narrow and deterministic — NOT fuzzy matching:
//   - lowercase
//   - strip apostrophes (straight/curly), periods, hyphens
//   - collapse internal whitespace, trim
export function normalizeIdentityName(raw: string): string {
  return raw
    .toLowerCase()
    .replace(/['’.\-]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
